export default __webpack_public_path__ + "static/hfn1-052e8c4aefa3287b9173f58ba8dbfefc.jpg";